import { Moon, Sun } from "lucide-react";
import { Switch } from "../ui/components/Switch";
import { useTheme } from "./useTheme";

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <div className="flex items-center gap-2">
      <Sun className="h-4 w-4 text-muted-foreground" />
      <Switch isSelected={isDark} onChange={toggleTheme} aria-label="Toggle dark mode" />
      <Moon className="h-4 w-4 text-muted-foreground" />
    </div>
  );
}
